var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalAllergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187497",
    "data-name": "Group 187497",
    transform: "translate(-325 -266.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325 266.26)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185859",
    "data-name": "Group 185859",
    transform: "translate(331.068 272.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185860",
    "data-name": "Group 185860",
    transform: "translate(0.932 0.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17922",
    "data-name": "Path 17922",
    d: "M50.948,36.928l2.607-2.607a1.7,1.7,0,0,1-.158-1.154,1.544,1.544,0,1,1,2.939.933,1.5,1.5,0,0,1-2.034.864.279.279,0,0,0-.378.074q-1.244,1.26-2.5,2.5c-.138.136-.172.256-.068.4a2.165,2.165,0,0,0,.372.458c.223.18.483.313.722.475a1.35,1.35,0,0,1,.641,1.269c-.016.253-.04.506-.078.756a1.211,1.211,0,0,0,.181.85c.173.282.309.586.479.869a.328.328,0,0,0,.231.138c.393.014.787,0,1.18.01a.294.294,0,0,0,.331-.2,1.262,1.262,0,0,1,1.37-.743,1.311,1.311,0,0,1,1.093,1.027,1.327,1.327,0,0,1-.847,1.532,1.27,1.27,0,0,1-1.594-.647.35.35,0,0,0-.392-.236c-.376.013-.752.009-1.128,0a.244.244,0,0,0-.271.174,7.358,7.358,0,0,1-.45.826,1.248,1.248,0,0,0-.183.875,7.186,7.186,0,0,1,.074.835,1.233,1.233,0,0,1-.531,1.084c-.211.155-.438.287-.652.438a2.191,2.191,0,0,0-.405.327c-.273.315-.257.47.034.762.117.118.24.231.348.357a.346.346,0,0,1-.016.514.336.336,0,0,1-.495,0,5.629,5.629,0,0,1-.375-.439,1.726,1.726,0,0,1-1.679.868,1.175,1.175,0,0,0-.928.414,1.864,1.864,0,0,1-2.559.613.8.8,0,0,0-.118-.035v2.025c.072.034.151.068.227.108a1.286,1.286,0,0,1,.673,1.455,1.326,1.326,0,0,1-2.58.013,1.251,1.251,0,0,1,.667-1.453.4.4,0,0,0,.261-.457c-.011-.542-.005-1.084-.008-1.626,0-.015-.013-.029-.029-.064l-.687.229a1.308,1.308,0,0,1-1.511-.359,2.478,2.478,0,0,0-1.953-.932,1.245,1.245,0,0,1-1.073-.7l-1.113,1.119a3.988,3.988,0,0,1,.044.919,1.281,1.281,0,0,1-1.61.989,1.331,1.331,0,0,1-.935-1.658,1.287,1.287,0,0,1,1.686-.857.3.3,0,0,0,.383-.081c.355-.374.723-.736,1.093-1.1.1-.1.145-.2.06-.319a3.523,3.523,0,0,0-.411-.523,2.288,2.288,0,0,0-.484-.31,1.533,1.533,0,0,1-.831-1.781,1.85,1.85,0,0,0-.336-1.579,4.143,4.143,0,0,1-.34-.662H35.316c-.044.091-.081.179-.127.263a1.287,1.287,0,0,1-1.471.636,1.313,1.313,0,0,1-.99-1.292,1.332,1.332,0,0,1,1.01-1.28,1.268,1.268,0,0,1,1.454.671.386.386,0,0,0,.43.262c.427-.02.856-.006,1.244-.006.218-.384.441-.729.615-1.1a1.624,1.624,0,0,0,.14-.65c.005-.33-.052-.661-.067-.992a1.16,1.16,0,0,1,.466-1.007c.226-.177.475-.326.712-.489a2.632,2.632,0,0,0,.337-.247c.333-.319.332-.545.014-.864l-1.977-1.98c-1.084.405-1.785.236-2.256-.534a1.6,1.6,0,0,1,.268-2.035,1.644,1.644,0,0,1,2.075-.139,1.6,1.6,0,0,1,.443,2.131l2.054,2.054a1.553,1.553,0,0,1,1.5-.758,1.52,1.52,0,0,0,1.193-.557,1.712,1.712,0,0,1,2.28-.536,2.665,2.665,0,0,0,.281.1V33.135c-.088-.042-.176-.08-.261-.126a1.3,1.3,0,0,1-.655-1.467,1.328,1.328,0,0,1,2.58.026A1.246,1.246,0,0,1,45.947,33a.409.409,0,0,0-.263.457c.012.559,0,1.118,0,1.7.294-.092.566-.184.841-.263a1.262,1.262,0,0,1,1.25.267c.223.2.437.4.641.618a.336.336,0,0,1-.007.514.347.347,0,0,1-.517-.005,5.91,5.91,0,0,1-.446-.444.739.739,0,0,0-.88-.2c-.164.059-.332.109-.494.174a2.023,2.023,0,0,1-1.508.006c-1.058-.393-1.018-.377-1.761.407a2.24,2.24,0,0,1-1.573.666c-.139.009-.277.034-.416.053a.627.627,0,0,0-.53.414,5.76,5.76,0,0,0-.2.566,1.857,1.857,0,0,1-1,1.251,1.173,1.173,0,0,0-.752,1.508,1.868,1.868,0,0,1-.407,1.674,1.093,1.093,0,0,0,0,1.553,2.072,2.072,0,0,1,.386,1.833.958.958,0,0,0,.553,1.208,2.247,2.247,0,0,1,1.292,1.618.924.924,0,0,0,1,.8,2.3,2.3,0,0,1,1.884.919.894.894,0,0,0,1.207.269,2.318,2.318,0,0,1,2.121,0,.907.907,0,0,0,1.227-.282,2.276,2.276,0,0,1,1.864-.9.923.923,0,0,0,1.006-.8,2.288,2.288,0,0,1,1.311-1.635.906.906,0,0,0,.539-1.138,2.238,2.238,0,0,1,.43-1.977,2.539,2.539,0,0,0,.215-.359.663.663,0,0,0,0-.676,2.6,2.6,0,0,0-.217-.358,2.247,2.247,0,0,1-.424-1.978.893.893,0,0,0-.525-1.12,2.376,2.376,0,0,1-1.34-1.677.846.846,0,0,0-.766-.744.337.337,0,0,1-.309-.412.359.359,0,0,1,.446-.3,1.327,1.327,0,0,1,1.119.727M36.232,33.164a.88.88,0,0,0-.883.907.889.889,0,0,0,.888.88.9.9,0,0,0,.9-.9.889.889,0,0,0-.905-.889m18.643-.411a.811.811,0,0,0,.021,1.621.811.811,0,1,0-.021-1.621M56.58,43.716a.594.594,0,0,0,.593-.577.591.591,0,1,0-.593.577M45.9,54.4a.592.592,0,0,0-.572-.6.59.59,0,0,0-.014,1.181A.593.593,0,0,0,45.9,54.4m-7.968-3.293a.584.584,0,1,0-1.169-.012.584.584,0,0,0,1.169.012M45.9,31.868a.584.584,0,1,0-1.168.01.572.572,0,0,0,.588.571.578.578,0,0,0,.58-.581m-11.84,10.68a.584.584,0,1,0,.572.587.572.572,0,0,0-.572-.587",
    transform: "translate(-32.728 -30.543)",
    fill: "#61277f",
    stroke: "#006dab",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17923",
    "data-name": "Path 17923",
    d: "M358.577,564.573a1.875,1.875,0,1,1-1.869-1.9,1.881,1.881,0,0,1,1.869,1.9m-.738-.016a1.138,1.138,0,1,0-1.148,1.149,1.14,1.14,0,0,0,1.148-1.149",
    transform: "translate(-346.598 -549.082)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17924",
    "data-name": "Path 17924",
    d: "M799.788,798.015c-.2-.185-.4-.364-.591-.556a.364.364,0,0,1-.05-.554c.161-.169.369-.159.573.041.187.183.365.376.559.576a1.7,1.7,0,0,1,1.493-.114,1.519,1.519,0,0,1,.771.718,1.6,1.6,0,1,1-2.754-.111m2.194.849a.862.862,0,0,0-.862-.866.881.881,0,0,0-.866.869.863.863,0,0,0,.869.858.85.85,0,0,0,.859-.862",
    transform: "translate(-779.462 -777.21)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17925",
    "data-name": "Path 17925",
    d: "M622.554,442.961a1.322,1.322,0,1,1-1.33-1.336,1.327,1.327,0,0,1,1.33,1.336m-.739,0a.584.584,0,1,0-.586.582.586.586,0,0,0,.586-.582",
    transform: "translate(-604.908 -431.123)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17926",
    "data-name": "Path 17926",
    d: "M377.479,320.509a1.322,1.322,0,1,1,1.333-1.333,1.327,1.327,0,0,1-1.333,1.333m0-.739a.584.584,0,1,0-.588-.58.587.587,0,0,0,.588.58",
    transform: "translate(-367.377 -310.524)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17927",
    "data-name": "Path 17927",
    d: "M136.2,133.12a.89.89,0,0,1,.905.889.9.9,0,0,1-.9.9.889.889,0,0,1-.888-.88.88.88,0,0,1,.883-.907",
    transform: "translate(-132.699 -130.499)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17928",
    "data-name": "Path 17928",
    d: "M869.253,117.014a.811.811,0,1,1,.021,1.621.811.811,0,0,1-.021-1.621",
    transform: "translate(-847.107 -114.805)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17929",
    "data-name": "Path 17929",
    d: "M943.867,501.587a.592.592,0,0,1-.588-.581.59.59,0,0,1,1.181,0,.594.594,0,0,1-.592.577",
    transform: "translate(-920.016 -488.415)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17930",
    "data-name": "Path 17930",
    d: "M503.838,941.553a.584.584,0,1,1-1.168-.027.584.584,0,0,1,.6-.57.592.592,0,0,1,.572.6",
    transform: "translate(-490.663 -917.696)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17931",
    "data-name": "Path 17931",
    d: "M191.948,812.542a.585.585,0,1,1-.565-.6.579.579,0,0,1,.565.6",
    transform: "translate(-186.741 -791.977)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17932",
    "data-name": "Path 17932",
    d: "M503.823,59.985a.578.578,0,0,1-.58.581.572.572,0,0,1-.588-.571.584.584,0,1,1,1.168-.01",
    transform: "translate(-490.649 -58.66)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17933",
    "data-name": "Path 17933",
    d: "M62.169,500.4a.572.572,0,0,1,.572.587.579.579,0,0,1-.581.581.584.584,0,1,1,.008-1.168",
    transform: "translate(-60.835 -488.397)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17934",
    "data-name": "Path 17934",
    d: "M385.962,592.662a1.138,1.138,0,1,1-1.127-1.143,1.142,1.142,0,0,1,1.127,1.143",
    transform: "translate(-374.72 -577.187)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17935",
    "data-name": "Path 17935",
    d: "M848.272,845.094a.85.85,0,0,1-.859.862.863.863,0,0,1-.869-.858.88.88,0,0,1,.866-.869.862.862,0,0,1,.862.866",
    transform: "translate(-825.753 -823.439)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17936",
    "data-name": "Path 17936",
    d: "M649.968,471.16a.583.583,0,1,1-.567-.6.587.587,0,0,1,.567.6",
    transform: "translate(-633.062 -459.318)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17937",
    "data-name": "Path 17937",
    d: "M405.7,347.9a.584.584,0,1,1,.594-.574.587.587,0,0,1-.594.574",
    transform: "translate(-395.596 -338.655)",
    fill: "#61277f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalAllergy);
export default __webpack_public_path__ + "static/media/medical-allergy.c98153f23a990193a86834030aa91d44.svg";
export { ForwardRef as ReactComponent };